import {PlayerReduxState} from "../types";

export default function isHintConfirmation(state: PlayerReduxState): boolean {
  return state.isHintConfirmation
}